// @flow
export type Image = {
  original: string,
  tiny: string,
  small: string,
  medium: string,
  large: string
};

export type ImageApiItem = {
  original: string,
  tiny?: string,
  small?: string,
  medium?: string,
  large?: string
};

export default function modelImage(item: ImageApiItem): Image {
  return {
    original: item.original,
    tiny: item.tiny || item.small || item.medium || item.large || item.original,
    small: item.small || item.medium || item.large || item.original,
    medium: item.medium || item.large || item.original,
    large: item.large || item.original
  };
}



// WEBPACK FOOTER //
// ./src/redux/models/image.js